import React, { useState } from 'react';
import axios from 'axios';
import arrowLeftIcon from '../assets/ion-arrow-back-outline-icon.svg';
import arrowRightIcon from '../assets/ion-arrow-forward-outline-icon.svg';
import closeIcon from '../assets/ion-close-icon.svg';
import okIcon from '../assets/ion-checkmark-icon.svg';

// Define the quiz questions and their correct answers
const questions = [
  {
    text: "86% respondentów odczuwało stres związany ze zmianą pracy. Jak często Polacy są zadowoleni z podjętej decyzji?",
    options: [
      { text: "70% badanych uznaje zmianę pracy za dobrą lub bardzo dobrą decyzję", isCorrect: true },
      { text: "58% badanych uznaje zmianę pracy za dobrą lub bardzo dobrą decyzję", isCorrect: false },
      { text: "35% badanych uznaje zmianę pracy za dobrą lub bardzo dobrą decyzję", isCorrect: false },
      { text: "15% badanych uznaje zmianę pracy za dobrą lub bardzo dobrą decyzję", isCorrect: false }
    ]
  },
  {
    text: "Aż 44% respondentów rozważa zmianę pracy w ciągu najbliższego roku. Ilu z nich prowadzi aktywne poszukiwania?",
    options: [
      { text: "60%", isCorrect: false },
      { text: "48%", isCorrect: false },
      { text: "28%", isCorrect: false },
      { text: "12%", isCorrect: true }
    ]
  },
  {
    text: "Co najczęściej powstrzymuje pracowników biurowych przed zmianą pracy?",
    options: [
      { text: "większy stres lub obciążenie", isCorrect: false },
      { text: "utrata stabilności zatrudnienia", isCorrect: true },
      { text: "brak możliwości rozwoju kompetencji", isCorrect: false },
      { text: "gorsza atmosfera / kultura organizacyjna", isCorrect: false }
    ]
  },
  {
    text: "Jak aktywizować biernych kandydatów na rynku pracy i przekonać ich, że to dobry moment na zmianę pracy?",
    type: "open"
  }
];

function Quiz({ email, onComplete, onQuit }) {
  // State for storing answers, current question, selected option, and transition state
  const [answers, setAnswers] = useState(Array(questions.length).fill(''));
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [openAnswer, setOpenAnswer] = useState('');

  // Modify the allQuestionsAnswered function
  const allQuestionsAnswered = () => {
    return answers.slice(0, -1).every(answer => answer !== '') && openAnswer !== '';
  };

  // Handle when an answer is selected
  const handleAnswer = (answer) => {
    setSelectedOption(answer);
    setIsTransitioning(true);

    setTimeout(() => {
      const newAnswers = [...answers];
      newAnswers[currentQuestion] = answer;
      setAnswers(newAnswers);

      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
      }
      setIsTransitioning(false);
      setSelectedOption(null);
    }, 500);
  };

  // Calculate the number of correct answers
  const calculateResult = () => {
    let correctCount = 0;
    answers.forEach((answer, index) => {
      const question = questions[index];
      if (question.options) {
        const selectedOption = question.options.find(option => option.text === answer);
        if (selectedOption && selectedOption.isCorrect) {
          correctCount++;
        }
      }
    });
    return correctCount.toString().concat(" / ", (questions.length - 1).toString()); // Return the count of correct answers
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!allQuestionsAnswered()) {
      alert('Proszę odpowiedzieć na wszystkie pytania przed zakończeniem quizu.');
      return;
    }

    try {
      const result = calculateResult();
      const response = await axios.post('https://api.olxquiz.pl/api/quiz', {
        email,
        answers: [...answers.slice(0, -1), openAnswer],
        result: result
      });
      onComplete(result, openAnswer); // Pass openAnswer to onComplete
      console.log('Quiz submitted successfully:', response.data);
    } catch (error) {
      console.error('Error submitting quiz:', error);
    }
  };

  // Add handleOpenAnswer function
  const handleOpenAnswer = (event) => {
    setOpenAnswer(event.target.value);
  };

  // Render the quiz component
  return (
    <div className="quiz-container">
      {/* Display current question number */}
      <div className="question-counter">
        Pytanie {currentQuestion + 1}/{questions.length}
      </div>
      
      {/* Display current question text */}
      <h2 className="question-text">{questions[currentQuestion].text}</h2>
      
      {/* Render question based on type */}
      {questions[currentQuestion].type === 'open' ? (
        <div className="open-question-container">
          <textarea
            value={openAnswer}
            onChange={handleOpenAnswer}
            placeholder="Wpisz swoją odpowiedź tutaj..."
            rows={5}
            disabled={isTransitioning}
          />
        </div>
      ) : (
        questions[currentQuestion].options.map((option, index) => (
          <div key={index} className="option-container">
            <input
              type="radio"
              id={`option-${index}`}
              name={`question-${currentQuestion}`}
              value={option.text}
              checked={answers[currentQuestion] === option.text || selectedOption === option.text}
              onChange={() => handleAnswer(option.text)}
              disabled={isTransitioning}
            />
            <label 
              htmlFor={`option-${index}`}
              className={selectedOption === option.text ? 'selected' : ''}
            >
              {option.text}
            </label>
          </div>
        ))
      )}
      
      {/* Navigation buttons */}
      <div className="button-container">
        {/* Previous question button */}
        {currentQuestion > 0 && (
          <button 
            onClick={() => setCurrentQuestion(currentQuestion - 1)} 
            className="prev-button"
            disabled={isTransitioning}
          >
            &laquo; Poprzednie
          </button>
        )}
        
        {/* Submit or Next question button */}
        {currentQuestion === questions.length - 1 ? (
          <button 
            onClick={handleSubmit} 
            className="submit-button"
            disabled={isTransitioning || !allQuestionsAnswered()}
          >
            <img src={okIcon} alt="Zakończ quiz"  /> Zakończ quiz
          </button>
        ) : (
          <button 
            onClick={() => setCurrentQuestion(currentQuestion + 1)} 
            className="next-button"
            disabled={isTransitioning}
          >
            Następne &raquo;
          </button>
        )}
      </div>

      { !allQuestionsAnswered() && (
          <div className="not-all-answered">Aby zakończyć quiz, odpowiedz na wszystkie pytania.</div>
      )}

      {/* Quit button */}
      <div className="quit-button-container">
        <button 
          onClick={onQuit} 
          className="quit-button"
          disabled={isTransitioning}
        >
          <img src={closeIcon} alt="Wyjdź i zmień email"  /> Wyjdź i zmień email
        </button>
      </div>
    </div>
  );
}

export default Quiz;